import { useEffect, useState } from "react";

const now = new Date();
// Ship day: next New Year's Day (January 1)
const LAUNCH = new Date(now.getFullYear() + (now.getMonth() === 0 && now.getDate() === 1 ? 0 : 1), 0, 1, 0, 0, 0, 0);

function diff() {
  const ms = Math.max(0, LAUNCH - new Date());
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    mins: Math.floor((ms / 60000) % 60),
    secs: Math.floor((ms / 1000) % 60),
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <div className="font-display text-3xl sm:text-4xl font-extrabold text-gold tabular-nums">
      {String(value).padStart(2, "0")}
    </div>
    <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-white/50 mt-1">{label}</div>
  </div>
);

export default function Countdown({ className = "" }) {
  const [t, setT] = useState(diff());
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className={`flex items-center gap-4 sm:gap-6 ${className}`} data-testid="countdown-timer">
      <Unit value={t.days} label="Days" />
      <span className="text-gold/40 text-2xl font-display -mt-3">:</span>
      <Unit value={t.hours} label="Hrs" />
      <span className="text-gold/40 text-2xl font-display -mt-3">:</span>
      <Unit value={t.mins} label="Min" />
      <span className="text-gold/40 text-2xl font-display -mt-3">:</span>
      <Unit value={t.secs} label="Sec" />
    </div>
  );
}
